import { Box, Divider, FabButton, MenuItem, Select, Typography } from '@dls/react-core';
import React, { BaseSyntheticEvent, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  StyledBlueHeading,
  StyledFormContainer,
  StyledTabPageContainer,
} from '../../../components/styled/styles';
import { Icon } from '@dls/react-icon';
import { Grid } from '@material-ui/core';
import { FormFooter } from '../../../components/styled/form-footer';
import { RoutePaths } from '../../../routes/main-routes';
import { StudyPageContext } from '../../../App';

// should come from BE
export const DEVICE_TYPES = ['PDL', 'EVA', 'HealthDot', 'HealthBand'];

export const StudyDevices = () => {
  const { study } = useContext(StudyPageContext);
  const [devices, setDevices] = useState<typeof DEVICE_TYPES>([]);
  const [selectedDevice, setSelectedDevice] = useState<string>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = (e: BaseSyntheticEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log(devices);
    setIsSubmitting(false);
  };

  const onSelectValueChange = (e: BaseSyntheticEvent) => {
    setSelectedDevice(e.target.value);
  };

  const onAddBtnClick = () => {
    if (selectedDevice && !devices.includes(selectedDevice)) {
      setDevices((devices) => [...devices, selectedDevice]);
    }
  };

  const onDeviceRemove = (d: string) => {
    setDevices(devices.filter((e) => e !== d));
  };

  return (
    <StyledTabPageContainer>
      <StyledBlueHeading variant="h2">Study devices</StyledBlueHeading>
      <StyledFormContainer onSubmit={onSubmit}>
        <Typography gutterBottom weight="bold" variant="body1" className={`mb0`}>
          Select device types
        </Typography>
        <Typography gutterBottom>Select the devices you would like to use in this study</Typography>
        <Select
          onChange={(e) => onSelectValueChange(e)}
          style={{ minWidth: `16rem` }}
          className={'DLSDropdown'}
          value={selectedDevice || undefined}
        >
          {DEVICE_TYPES.map((d, i) => (
            <MenuItem key={i} value={d}>
              <span>{d}</span>
            </MenuItem>
          ))}
        </Select>
        <FabButton
          disabled={!selectedDevice}
          style={{ marginLeft: `8px` }}
          size="small"
          variant="extended"
          dls_variant="primary"
          onClick={onAddBtnClick}
        >
          <Icon name={'Plus'} color="white" size={'m'} />
        </FabButton>

        {devices && (
          <Grid style={{ marginTop: `48px`, minHeight: `20vh` }} container spacing={3}>
            {devices.map((d, i) => (
              <Grid key={i} item xs={12} md={4}>
                <Box
                  style={{
                    display: `flex`,
                    flexDirection: `row`,
                    justifyContent: `space-between`,
                    rowGap: 8,
                    width: `100%`,
                    textAlign: `left`,
                    height: `auto`,
                  }}
                >
                  <Typography variant="body2">{d}</Typography>
                  <FabButton
                    onClick={() => onDeviceRemove(d)}
                    size="small"
                    variant="extended"
                    dls_variant="quietEmphasis"
                  >
                    <Icon name="Cross" size={'m'} />
                  </FabButton>
                </Box>
                <Divider variant={`fullWidth`} />
              </Grid>
            ))}
          </Grid>
        )}
        <FormFooter
          isSubmitting={isSubmitting}
          onCancel={() => navigate(`/${RoutePaths.Studies}/${study.id}`)}
        />
      </StyledFormContainer>
    </StyledTabPageContainer>
  );
};
